export default __webpack_public_path__ + "static/media/continuousImprovement_icon.99ce0e82.webp";